/**
 * Getting the list of badges based on type of the product
 * @param {Product} product
 * @returns {BadgesList}
 */

function _getAllBadges(product) {
  let pricings = [product.pricing];

  if (product.detail.flags.consolidatedMaster) {
    const latchKeyToProductMap = product.relationships?.latchKeyToProductMap || {};
    const latchkeyPricings = Object.values(latchKeyToProductMap).map((latchkeyData) => latchkeyData.pricing);

    pricings = pricings.concat(latchkeyPricings);
  } else if (product.detail.flags.consolidatedProductComplex) {
    const sizeMap = product.traits?.sizes?.sizeMap || {};
    const memberPricings = Object.values(sizeMap).map((sizeData) => sizeData.pricing);

    pricings = pricings.concat(memberPricings);
  }

  /** @type {BadgesList} */
  const accumulator = [];

  return pricings
    .filter((pricing) => !!pricing)
    .reduce((result, pricing) => result.concat(Object.values(pricing.badgesMap || {})), accumulator);
}

/**
 * Updating badge data with initial validation properties.
 * Should be evoke on server side only
 * @param {Product} product
 * @returns {void}
 */
export function updateBadgeData(product) {
  return _getAllBadges(product).forEach((badge) => {
    // Some badges may be hidden based on user's signedIn status
    // Hide on server-side render and show if validated on client side
    badge.validateOnClient = (
      !!badge.loyaltyEligibleTier
          || badge.promotionType === 'Free Shipping'
    );
    badge.active = true;
    badge.isSelectColorsOnly = !badge.applicableToAllUpcs && !badge.rebateInfo;
    badge.isShowRebateInfo = !badge.applicableToAllUpcs && !!badge.rebateInfo;
    badge.isShowMorePromotionDetails = (
      !!badge.legalDisclaimer
        || !!badge.giftProducts
            || !!badge.isShowRebateInfo
    );
  });
}

export default updateBadgeData;
